"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var epsilon_ajax_request_1 = require("../../utils/epsilon-ajax-request");
var EpsilonTypographyPreviewer = /** @class */ (function () {
    /**
     * Constructor
     */
    function EpsilonTypographyPreviewer() {
        var self = this;
        wp.customize.preview.bind('update-inline-typography-css', function (object) {
            var style, data = {
                action: [object.class, object.action],
                nonce: EpsilonWPUrls.ajax_nonce,
                args: object.data,
                id: object.id
            }, Ajax;
            Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(data);
            Ajax.request();
            jQuery(Ajax).on('epsilon-received-success', function (e) {
                style = jQuery('#' + Ajax.result.stylesheet + '-inline-css');
                if (!style.length) {
                    style = jQuery('body').append('<style type="text/css" id="' + Ajax.result.stylesheet + '-inline-css" />').find('#' + Ajax.result.stylesheet + '-inline-css');
                }
                for (var i = 0; i < Ajax.result.fonts.length; i++) {
                    if (!jQuery('link[href="https://fonts.googleapis.com/css?family=' + Ajax.result.fonts[i] + '"]').length) {
                        jQuery('head').append('<link href="https://fonts.googleapis.com/css?family=' + Ajax.result.fonts[i] + '" rel="stylesheet">');
                    }
                }
                style.html(Ajax.result.css);
            });
        });
    }
    return EpsilonTypographyPreviewer;
}());
exports.EpsilonTypographyPreviewer = EpsilonTypographyPreviewer;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/previewer/typography/typography.ts
// module id = 32
// module chunks = 1